module.exports = __webpack_public_path__ + "media/images/new_landing/for/price-1-f1ac27f7fbe4782b44e949e31adbc2bf.png";